import React, { Component } from 'react';
import Paginacaocss from './Paginacao-css';
const useStyles = Paginacaocss();

const PaginacaoStyle = (props) => {
      
  const classeStyles = useStyles();

  //declara variaveis auxiliares
  var renderPageNumbers = null;
  //verifica se tem paginas para listar
  if (props.state.totalPagina !== null) {
    
    //retorna numero de paginas que devem ser listadas
    var pageNumbers = props.getPageNumbers();
    
    //cria spans com numeros e define qual ativo
    renderPageNumbers = pageNumbers.map(number => {
      var classes = props.state.current_page === number ? classeStyles.active : '';
      return <span key={number} className={classes} onClick={() => {props.makeHttpRequestWithPage(number)}}>{number}</span>;
    });
  }
  
  //calcula quantidade para feedback
  var countDe = null;
  var countAte = null;
  var qtdPages = Math.ceil(props.state.totalPagina / 7);
  if (qtdPages === props.state.current_page) {
    countDe = (props.state.current_page-1)*7;
    countAte = props.state.totalPagina;
  } else {
    countDe = (props.state.current_page-1)*7;
    countAte = ((props.state.current_page-1)*7)+7;
  }

  return (
    <div>
      {countDe + " - " + countAte + " de " + props.state.totalPagina}
      <div className={classeStyles.paginationPedidos}>
        {props.state.current_page!==1 && 
          <span onClick={(e) => {props.makeHttpRequestWithPage(props.state.current_page-1)}}>❮</span>
        }
        {renderPageNumbers}
        {props.state.current_page !== props.getPageNumbers().length && props.getPageNumbers().length !== 0 && 
          <span onClick={(e) => {props.makeHttpRequestWithPage(props.state.current_page+1)}}>❯</span>
        }
      </div>
    </div>
  );

}

export default class Paginacao extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      totalPagina: this.props.state.totalPagina,
      per_page: 7,
      current_page: this.props.state.current_page
    }

    this.makeHttpRequestWithPage = this.makeHttpRequestWithPage.bind(this);
    this.getPageNumbers = this.getPageNumbers.bind(this); 
  }

  async makeHttpRequestWithPage(page) {
    //atualiza pagina atual
    await this.props.setState({
      current_page: page
    });

    //dispara request para atualizar dados
    var filters = {};
    await this.props.loadData(filters);
  }

  getPageNumbers () {
    var pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.state.totalPagina / this.state.per_page); i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  }
  
  render() {
    return (<PaginacaoStyle {...this}/>)
  }
}
